import React, { useEffect, useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import { light } from 'theme/palette';
import MuiListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { useHistory } from 'react-router-dom';
import { useLocation } from 'react-router';
import { FaChevronDown, FaChevronUp, FaBarcode, FaUsers, FaTools } from 'react-icons/fa';
import { AiOutlineLineChart, AiFillReconciliation } from 'react-icons/ai';
import { HiOutlineDocumentReport } from 'react-icons/all';
import pages from './pages';
import PermissionsComponent from '../../Wrappers/PermissionsComponent';

export const styles = (theme) => {
  return {
    /* Styles applied to the (normally root) `component` element. May be wrapped by a `container`. */
    root: {
      '&$focusVisible': {
        backgroundColor: theme.palette.action.selected,
      },
      '&$selected, &$selected:hover': {
        backgroundColor: theme.palette.action.selected,
      },
      '&$disabled': {
        opacity: 0.5,
      },
    },
    /* Pseudo-class applied to the `component`'s `focusVisibleClassName` prop if `button={true}`. */
    focusVisible: {},
    /* Styles applied to the inner `component` element if `button={true}`. */
    button: {
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.shortest,
      }),
      '&:hover': {
        textDecoration: 'none',
        backgroundColor: theme.palette.action.hover,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent',
        },
      },
    },
    /* Pseudo-class applied to the root element if `selected={true}`. */
    selected: {},
  };
};

const useStyles = makeStyles((_theme) => {
  return {
    root: {
      width: '100%',
      maxWidth: 360,
    },
    itemIcon: {
      minWidth: 32,
    },
    subMenu: {
      backgroundColor: '#badbf7',
      color: '#2e4152',
      maxWidth: 360,
    },
  };
});

const ListItem = withStyles((theme) => {
  return {
    root: {
      borderLeft: '5px solid transparent',
      '&$selected': {
        backgroundColor: theme.palette.primary.dark,
        color: theme.palette.alternate.dark,
        '& .MuiListItemIcon-root': {
          color: theme.palette.alternate.dark,
        },
      },
      '&$selected:hover': {
        backgroundColor: theme.palette.primary.dark,
        color: theme.palette.alternate.dark,
        '& .MuiListItemIcon-root': {
          color: theme.palette.alternate.dark,
        },
      },
      '&:hover': {
        borderLeft: `5px solid ${ theme.palette.primary.dark }`,
        color: theme.palette.primary.contrastText,
        '& .MuiListItemIcon-root': {
          color: theme.palette.primary.contrastText,
        },
      },
    },
    selected: {},
  };
})(MuiListItem);

export const menuStructure = [
  { key: 'reports',
    title: 'Reports',
    icon: AiOutlineLineChart,
    permission: 'VIEW_REPORTS_MENU',
    subMenus: [ '/submenu/reports', '/cardio-reports', '/3in1-reports', '/nutrition-reports', '/vitamins-reports', '/bio-age-reports', '/nutrigenetix-reports', '/pgx-reports' ] },
  { key: 'serial',
    title: 'Serial',
    icon: FaBarcode,
    permission: 'VIEW_SERIAL_MENU',
    subMenus: [ '/submenu/serial', '/serial-numbers', '/serial_details' ] },
  { key: 'registration',
    title: 'Registration',
    icon: AiFillReconciliation,
    permission: 'VIEW_REGISTRATION_MENU',
    subMenus: [ '/submenu/registration', '/doctor_kit_management', '/corporate_kit_management', '/registration_kit_management', '/doctors-kit-correlation' ] },
  { key: 'management',
    title: 'B2B Management',
    icon: FaUsers,
    permission: 'VIEW_MANAGEMENT_MENU',
    subMenus: [ '/submenu/management', '/doctors', '/corporation-management' ] },
  { key: 'tools',
    title: 'Tools',
    icon: FaTools,
    permission: 'VIEW_TOOLS_MENU',
    subMenus: [ '/submenu/tools', '/appointments', '/translations', '/questions', '/email-templates', '/promo-codes' ] },
  { key: 'miscellaneous',
    title: 'Miscellaneous',
    icon: HiOutlineDocumentReport,
    permission: 'VIEW_MISCELLANEOUS_MENU',
    subMenus: [ '/submenu/miscellaneous', '/thematic', '/traits', '/association-reports', '/upgraded-kits' ] },
  { key: 'lab',
    title: 'Lab',
    icon: HiOutlineDocumentReport,
    permission: 'VIEW_LAB_MENU',
    subMenus: [ '/submenu/lab', '/lab-files', '/lab-samples' ] },
  { key: 'manager',
    title: 'Local Manager',
    icon: HiOutlineDocumentReport,
    permission: 'VIEW_MANAGER_MENU',
    subMenus: [ '/submenu/manager', '/manager-serials', '/manager-serialDashboard', '/manager-registrations', '/manager-doctors', '/manager-corporate' ] },
  { key: 'users', title: 'Admin Users Managemenet', icon: FaUsers, permission: 'VIEW_USERS_PAGE' },
];

export const isSubMenu = (menu) => {
  const subMenus = menuStructure.filter((m) => { return m.key !== 'users'; });
  return subMenus.some((s) => { return s.key === menu; });
};

const PagesMenu = () => {
  const classes = useStyles();
  const location = useLocation();
  const [ selectedPage, setSelectedPage ] = useState('');

  const [ subMenus, setSubMenus ] = useState({
    reports: false,
    management: false,
    serial: false,
    registration: false,
    miscellaneous: false,
    lab: false,
    tools: false,
    manager: false,
  });

  const isActiveSubMenu = (menu) => {
    return subMenus[menu] && isSubMenu(menu);
  };

  const history = useHistory();

  useEffect(() => {
    if (location.pathname !== selectedPage) {
      setSelectedPage(location.pathname);

      const matchedKey = menuStructure.find((item) => {
        return item.subMenus?.includes(location.pathname);
      })?.key;

      if (matchedKey) {
        setSubMenus((prev) => {
          const updated = Object.keys(prev).reduce((subMenuStates, key) => {
            subMenuStates[key] = false;
            return subMenuStates;
          }, {});
          updated[matchedKey] = true;
          return updated;
        });
      }
    }
    if (location.pathname === '/') { // If home page is selected
      setSubMenus({
        reports: false,
        management: false,
        serial: false,
        registration: false,
        miscellaneous: false,
        lab: false,
        tools: false,
        manager: false,
      });
    }
  }, [ location, selectedPage ]);

  const handleListItemClick = (event, path) => {
    setSelectedPage(path);
    history.push(path);
  };

  return (
    <div className={ classes.root }>
      <List component='nav' aria-label='main'>
        {
          pages.map((page) => {
            const { title, path, permissions, icon: Icon, menu } = page;
            return (
              <PermissionsComponent key={ path } permissions={ permissions }>
                { (menu === 'main' || isActiveSubMenu(menu))
                    && (
                      <ListItem
                        className={ menuStructure.some((item) => { return item.key === menu; }) && classes.subMenu }
                        button
                        selected={ selectedPage === path }
                        onClick={ (event) => { return handleListItemClick(event, path); } }
                      >
                        <ListItemIcon className={ classes.itemIcon }>
                          <Icon />
                        </ListItemIcon>
                        <ListItemText primary={ title } />
                      </ListItem>
                    )}
                {menu === 'folder' && menuStructure.some((item) => { return item.title === title; }) && (
                  <ListItem
                    button
                    onClick={ () => {
                      const item = menuStructure.find((i) => { return i.title === title; });

                      if (item) {
                        setSubMenus((prev) => {
                          const newState = Object.fromEntries(
                            Object.keys(prev).map((k) => { return [ k, false ]; }),
                          );
                          return { ...newState, [item.key]: !prev[item.key] };
                        });
                      } else {
                        console.log('No Menu');
                      }
                    } }
                  >
                    <ListItemIcon className={ classes.itemIcon }>
                      <Icon />
                    </ListItemIcon>
                    <ListItemText primary={ title } />
                    {(() => {
                      const item = menuStructure.find((it) => { return it.title === title; });
                      if (!item) { return null; }

                      const ArrowIcon = subMenus[item.key] ? FaChevronUp : FaChevronDown;
                      return <ArrowIcon color={ light.text.secondary } />;
                    })()}

                  </ListItem>
                )}

              </PermissionsComponent>
            );
          })
        }
      </List>
    </div>
  );
};

export default PagesMenu;
